module.exports = __webpack_public_path__ + "img/modulo_QRCode.6eb9edd.svg";